/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { SettingsServiceItem, UpdateSettingsServiceApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateSettingsService: build.mutation<SettingsServiceItem, UpdateSettingsServiceApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/settings/services/${queryArg.serviceId}`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as updateSettingsServiceApi };
export const { useUpdateSettingsServiceMutation } = injectedRtkApi;
